import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['leader', 'follower'];

  toggle() {
    this.followerTargets.forEach(checkbox => checkbox.checked = this.leaderTarget.checked);
  }

  selectSingleCheckbox(event) {
    // Uncheck the leader checkbox.
    this.leaderTarget.checked = false;
    this.leaderTarget.indeterminate = true;
    // Set the current follower checkbox to true.
    this.followerTargets.forEach(checkbox => checkbox.checked = (checkbox.value == event.target.dataset.id));
  }

  toggleLeaderCheckbox() {
    const checkStatus = this.followerTargets.map(target => target.checked);
    const allChecked  = checkStatus.every(Boolean);
    const someChecked = checkStatus.some(Boolean);

    this.leaderTarget.checked = allChecked;
    this.leaderTarget.indeterminate = !allChecked && allChecked !== someChecked;
  }

  unselect() {
    this.leaderTarget.checked = false;
    this.leaderTarget.indeterminate = false;
    this.followerTargets.forEach(checkbox => checkbox.checked = false);
  }
}
